import { render, staticRenderFns } from "./detail-images.vue?vue&type=template&id=5c802dfa&scoped=true&"
import script from "./detail-images.vue?vue&type=script&lang=js&"
export * from "./detail-images.vue?vue&type=script&lang=js&"
import style0 from "./detail-images.vue?vue&type=style&index=0&id=5c802dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c802dfa",
  null
  
)

export default component.exports